/* src/tutors/cards/SettingsCard/styles.js */

export default theme => ({
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: theme.spacing.unit * 100,
    height: theme.spacing.unit * 80,
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
  },
  header: {
    padding: theme.spacing.unit * 2,
  },
});



// WEBPACK FOOTER //
// ./src/modules/tutors/cards/SettingsCard/styles.js